/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { AnyAction } from '@reduxjs/toolkit';
import * as actionTypes from '../constants/action-types';


type State = { loaded: true, token: string } | { loaded: false, token: undefined }
const defaultState: State = { token: undefined, loaded: false };

const authenticationToken = (state: State = defaultState, action: AnyAction): State => {
  switch (action.type) {
    case actionTypes.AUTHENTICATION_TOKEN_LOADED:
      return { ...state, loaded: true, token: action.token }
    case actionTypes.AUTHENTICATION_TOKEN_UNLOADED:
      return { ...state, loaded: false, token: undefined }
    default:
      return state;
  }
}

export default authenticationToken;
